import {
  ApprovalRequestActionReq,
  CreateGroupMemberConnectionApprovalRequestReq,
} from '../dto/ReqDtoRepository';
import {
  ApprovalRequestListResponse,
  ApprovalRequestResponse,
} from '../dto/ResDtoRepository';
import { sendApiRequest } from './apiConfig';

const buildActionPath = (
  requestId: string,
  action: 'accept' | 'reject' | 'cancel' | 'acknowledge',
  aui: string,
) => `/api/v1/approval-request/${encodeURIComponent(requestId)}/${action}?aui=${encodeURIComponent(aui)}`;

export const getApprovalRequestList = async (
  aui: string,
): Promise<ApprovalRequestListResponse> => {
  return sendApiRequest<ApprovalRequestListResponse>(
    'get',
    `/api/v1/approval-request/list?aui=${encodeURIComponent(aui)}`,
  );
};

export const createGroupMemberConnectionApprovalRequest = async (
  aui: string,
  data: CreateGroupMemberConnectionApprovalRequestReq,
): Promise<ApprovalRequestResponse> => {
  return sendApiRequest<ApprovalRequestResponse>(
    'post',
    `/api/v1/approval-request/group-member-connection?aui=${encodeURIComponent(aui)}`,
    data,
  );
};

export const acceptApprovalRequest = async (
  aui: string,
  data: ApprovalRequestActionReq,
): Promise<ApprovalRequestResponse> => {
  return sendApiRequest<ApprovalRequestResponse>(
    'put',
    buildActionPath(data.id, 'accept', aui),
  );
};

export const rejectApprovalRequest = async (
  aui: string,
  data: ApprovalRequestActionReq,
): Promise<ApprovalRequestResponse> => {
  return sendApiRequest<ApprovalRequestResponse>(
    'put',
    buildActionPath(data.id, 'reject', aui),
  );
};

export const cancelApprovalRequest = async (
  aui: string,
  data: ApprovalRequestActionReq,
): Promise<ApprovalRequestResponse> => {
  return sendApiRequest<ApprovalRequestResponse>(
    'put',
    buildActionPath(data.id, 'cancel', aui),
  );
};

export const acknowledgeApprovalRequest = async (
  aui: string,
  data: ApprovalRequestActionReq,
): Promise<ApprovalRequestResponse> => {
  return sendApiRequest<ApprovalRequestResponse>(
    'put',
    buildActionPath(data.id, 'acknowledge', aui),
  );
};
